import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import CardActionArea from '@mui/material/CardActionArea';
import { TypographyLargeBold, TypographyGray } from '../style/typography';

const SystemCard = ({ image, altText, title, description, onClick }) => {
    return (
        <Card sx={{ height: '100%' }}>
            <CardActionArea
                sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                }}
                onClick={onClick}
            >
                <CardMedia
                    component="img"
                    height="280"
                    image={image}
                    alt={altText}
                />
                <CardContent
                    sx={{
                        flexGrow: 1,
                        width: '100%',
                        boxSizing: 'border-box',
                        textAlign: 'center',
                    }}
                >
                    <TypographyLargeBold
                        sx={{ whiteSpace: 'pre-line'}}
                    >
                        {title}
                    </TypographyLargeBold>
                    <TypographyGray
                        sx={{ 
                            paddingTop: 1,
                            whiteSpace: 'pre-line'
                        }}
                    >
                        {description}
                    </TypographyGray>
                </CardContent>
            </CardActionArea>
        </Card>
    );
};

export default SystemCard;